<template>
  <vue-modal id="offlineModal"
             :width="$store.getters.isMobileDevice ? '100%' : '50%'"
             classes="vue-modal-container"
             height="auto"
             name="offline-modal"
             :clickToClose="true"
             @closed="modalClosed"
             @opened="modalOpened"
             >
    <div class="header">
      
      <div class='sign-container'>
        <div class='sign'>
            <i class="exclamation triangle icon"/>
            <div class='title'>Nincs hálózati kapcsolat!</div>
            <br/>
            <div class='action'>
            <div v-if="overallState==='SERVER'">A foglaljpályát.hu szolgáltatás nem elérhető, kérlek jelezd a pultosnál!</div>
            <div v-if="overallState==='NETWORK'">Nincs internetelérés, kérlek jelezd a pultosnál!</div>
            <div v-if="overallState==='OK'">OK</div>
            <div v-if="overallState==='PENDING'">Diagnosztika folyamatban...</div>
            </div>
            <br/>

        </div>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import config from '@/config'

export default {
  data () {
    return {
      serverOk : 'ellenőrzés...',
      googleOk : 'ellenőrzés...',
      timer: null,
    }
  },
  methods: {
    modalOpened (/*event*/) {
      this.serverOk = 'ellenőrzés...';
      this.googleOk = 'ellenőrzés...';

      this.timer = setInterval(() => {
        this.checkNetwork();        
      }, 10*1000);
      this.checkNetwork();
    },    
    modalClosed() {
      this.$store.commit('SET_OFFLINE_ERROR', false);
      clearTimeout(this.timer);
    },
    checkNetwork() {
      fetch(config.SERVER_DOMAIN + '/ping').then(() => {
        this.serverOk = 'OK';
      }, () => {
        this.serverOk = 'FAILED';
      })
      fetch('https://www.google.com', { mode: 'no-cors', headers: {'Cache-Control': 'no-cache' }}).then(() => {
        this.googleOk = 'OK';
      }, () => {
        this.googleOk = 'FAILED';
      })
    },
  },
  computed: {
    overallState() {
      if (this.serverOk === 'OK')
        return 'OK';
      if (this.serverOk === 'FAILED' && this.googleOk === 'OK')
        return 'SERVER';
      if (this.googleOk === 'FAILED')
        return 'NETWORK';
      return 'PENDING';
    }
  },
  watch: {
    overallState(v) {
      if (v === 'OK') {
        this.$modal.hide('offline-modal');
      }
    }
  }
}
</script>
<style scoped>
#offlineModal .content {
  text-align: center;
}
.sign-container {
    display: flex;
    align-items: center;
    justify-content: center;
    
}
.sign {
    background: red;
    color:#fff;
    padding: .3em 1em;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    text-align: center;
    gap: 1em;
}
.sign > i {
    font-size: 3em !important;
}

.sign > .title {
    font-size: 36px;
    font-weight: bold;
}
.sign > .action {
    font-weight: bold;
}

</style>

